import {Helmet} from 'react-helmet';
import Contact from "../../Page/contact";



const faqsContent ={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Do you offer website design services in Mumbai?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we provide professional website design and development services in Mumbai tailored for startups, businesses, and individuals."
      }
    },
    {
      "@type": "Question",
      "name": "How much does it cost to build a website in Mumbai?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Website prices start from ₹10,000 and vary depending on the design complexity, number of pages, and additional functionalities like forms or eCommerce."
      }
    },
    {
      "@type": "Question",
      "name": "Will the website be mobile-friendly and responsive?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, every website we create is fully responsive and optimized for mobile, tablet, and desktop devices."
      }
    },
    {
      "@type": "Question",
      "name": "Is the website SEO optimized?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we implement SEO best practices including meta tags, clean URLs, fast loading speeds, and schema markup to boost visibility on search engines."
      }
    },
    {
      "@type": "Question",
      "name": "Can I update my website content without technical knowledge?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, your website will be built on a user-friendly CMS like WordPress, allowing you to manage content, images, and blog posts easily."
      }
    },
    {
      "@type": "Question",
      "name": "Do you develop eCommerce websites in Mumbai?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we build custom eCommerce websites with shopping carts, payment gateway integration, inventory control, and order tracking features."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to complete a website project?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Standard business websites take around 5–7 working days. Complex or custom eCommerce websites may take 2–4 weeks."
      }
    },
    {
      "@type": "Question",
      "name": "Can you help with hosting, domain, and SSL setup?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we help with domain registration, hosting configuration, SSL installation, and custom email setup for your business."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide ongoing website maintenance?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we offer monthly and yearly maintenance plans that include backups, updates, security monitoring, and content changes."
      }
    },
    {
      "@type": "Question",
      "name": "How do I get started with a website project in Mumbai?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Simply contact us via the website or phone. We'll discuss your requirements and provide a custom proposal to get started."
      }
    }
  ]
}

function App1() {
  return (
   <>
 <Helmet>
  <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
<title>Pankaj | Website Designer In Mumbai</title>
<meta name="description" content="Top website designer in Mumbai. Get a modern website design with me in low cost. Elevate your online presence today!"/>
<meta name="keywords" content="web designing company in mumbai, website designer in mumbai, website development company mumbai, best website designers in mumbai, top website designers in mumbai, freelance website designers in mumbai, website designers in mumbai charges, website designer in goregaon, website developer near me"/>
<meta property="og:title" content="Pankaj | Website Designer In Mumbai" />
<meta property="og:description" content="Top Website Designer In Mumbai. Get a modern website design with me in low cost. Elevate your online presence today!" />
<meta property="og:site_name" content="Pankaj | Website Designer In Mumbai" />
<meta property="og:url" content="https://www.pankj.com/website-designer-in-mumbai"/>
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg"/>
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Pankaj | Website Designer In Mumbai" />
<meta name="twitter:description" content="Top website designer in Mumbai. Get a modern website design with me in low cost. Elevate your online presence today!" />
<link rel="canonical" href="https://www.pankj.com/website-designer-in-mumbai" />
        </Helmet>
 <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
                <source src="assets/img/bg.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />
  <h1 className="multiple_effects fzsml" id="text3d">Website Designer In Mumbai</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/pks2.webp" alt="Website Designer" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   

    <main id="main">
  <section id="pageContent" className="pageContent">

      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Website Designer in Mumbai</h2>
        </header>

        <div className="row">
          <div className="col-lg-12">
Welcome to Pankaj's Web Design Services, where creativity meets functionality! Based in the vibrant city of Mumbai, I specialize in crafting high-quality, flexible, and responsive websites tailored to meet the unique needs of your business. With over a decade of experience in full-stack development and a keen eye for design, I deliver websites that not only look stunning but also perform exceptionally well.
<h3>My Services:</h3>
<h4><strong>Custom Website Design</strong></h4>
Every business is unique, and your website should reflect that. I create custom website designs that align with your brand identity and engage your audience. Whether you need a sleek corporate site, an eye-catching portfolio, or an engaging blog, I've got you covered.
<h4><strong>E-Commerce Solutions</strong></h4>
Ready to take your business online? I design robust e-commerce websites that facilitate seamless shopping experiences. From intuitive navigation to secure payment gateways, I ensure your online store is fully equipped to boost sales and grow your customer base.
<h4><strong>Responsive Web Development</strong></h4>
In today’s mobile-driven world, having a responsive website is essential. I develop websites that look and function beautifully on all devices, ensuring your customers can access your content anytime, anywhere.
<h4><strong>SEO-Friendly Websites</strong></h4>
Getting found online is crucial. I implement best practices in SEO to enhance your website’s visibility on search engines, driving more traffic and potential customers to your site. My SEO strategies include keyword optimization, meta tags, and mobile-friendly design to ensure you rank higher on Google.
<h4><strong>Website Redesign</strong></h4>
Is your current website not performing as well as you'd like? I offer comprehensive redesign services to give your website a fresh, modern look and improve its functionality. Let’s revamp your site to better serve your audience and reflect your evolving brand.
<h4><strong>Content Management Systems (CMS)</strong></h4>
I utilize popular CMS platforms like WordPress to empower you to manage your website easily. This allows you to make updates and changes independently, saving you time and resources.
<h4><strong>Maintenance &amp; Support</strong></h4>
Once your website is live, I provide ongoing maintenance and support services to keep it running smoothly. From regular updates to troubleshooting issues, I'm here to ensure your website remains in top shape.
<h4><strong>Digital Marketing &amp; SEO Services</strong></h4>
In addition to website design, I offer basic digital marketing services to enhance your online presence. Whether it's social media marketing or content strategy, I can help you connect with your audience effectively.
<h3>Why Choose Me?</h3>
<ul>
  <li><strong>Experience</strong>: Over 10 years in web design and development, delivering high-quality results.</li>
  <li><strong>Client-Centric Approach</strong>: I work closely with you to understand your vision and goals, ensuring the final product exceeds your expectations.</li>
  <li><strong>Affordable Solutions</strong>: Quality doesn’t have to break the bank. I offer competitive pricing tailored to your needs.</li>
  <li><strong>Timely Delivery</strong>: I respect your deadlines and am committed to delivering projects on time.</li>
</ul>
Let’s collaborate to create a stunning website that elevates your brand and engages your audience. Contact me today to discuss your project and get a free quote!

<h2>Frequently Asked Questions</h2>

<h4>1. What services do you offer as a website designer?</h4>
<p>I offer a range of services including custom website design, e-commerce solutions, responsive web development, SEO-friendly websites, website redesign, CMS implementation, ongoing maintenance and support, as well as basic digital marketing services.</p>

<h4>2. How long does it take to design and develop a website?</h4>
<p>The timeline for designing and developing a website can vary based on its complexity and your specific requirements. Generally, a basic website can take 2-4 weeks, while more complex projects may take longer. I will provide you with a detailed timeline during our initial consultation.</p>

<h4>3. Will my website be mobile-friendly?</h4>
<p>Absolutely! All websites I design are fully responsive, meaning they will work seamlessly on all devices, including desktops, tablets, and smartphones. This ensures a great user experience for your visitors, regardless of how they access your site.</p>

<h4>4. Can you help with SEO for my website?</h4>
<p>Yes, I incorporate SEO best practices into the website design process to improve your site’s visibility on search engines. This includes optimizing your site’s structure, content, and images, as well as implementing keyword strategies to help drive organic traffic.</p>

<h4>5. Do you provide ongoing support after the website is launched?</h4>
<p>Yes, I offer maintenance and support services to ensure your website runs smoothly after launch. This includes regular updates, troubleshooting, and assistance with any issues that may arise.</p>

<h4>6. How do I update my website after it’s launched?</h4>
<p>If you choose to use a Content Management System (CMS) like WordPress, you will have the ability to update your website content independently. I will provide you with training on how to manage your site. For other changes or updates, I’m always available to assist you.</p>

<h4>7. What is the cost of your website design services?</h4>
<p>The cost of website design services depends on various factors such as the complexity of the project, features required, and your specific needs. I provide a free quote after discussing your project in detail, ensuring you receive a solution that fits your budget.</p>

<h4>8. Can you redesign my existing website?</h4>
<p>Yes, I offer website redesign services to refresh and improve your current site. This may involve updating the layout, enhancing functionality, and optimizing for better performance and user experience.</p>

<h4>9. How do we get started on a project?</h4>
<p>To get started, simply contact me through my website or reach out via email or phone. We’ll schedule a consultation to discuss your project goals, timeline, and budget, allowing us to create a tailored plan for your website.</p>

<h4>10. Why should I choose you as my website designer?</h4>
<p>With over a decade of experience, a client-centric approach, and a commitment to delivering high-quality results on time, I am dedicated to helping you create a website that meets your needs and exceeds your expectations. Your satisfaction is my priority!</p>


          </div>
        </div>
      </div>

    </section>
 <Contact />
    </main>
    </>
  );
}
export default App1;
